export default {
  data() {
    return {
      // eslint-disable-next-line
      typeOptions: [
        "Business",
        "Technical",
        "Hazard"
      ],
      // eslint-disable-next-line
      riskTypeOptions: [
        "Safety",
        "Production",
        "Activity",
        "Process",
        "People"
      ],
      // eslint-disable-next-line
      riskEvaulationsOptions: [
        "ALARP",
        "Tolerable",
        "Weakness"
      ],
      // eslint-disable-next-line
      riskOutcomeRecommendationOptions: [
        "BAU",
        "MON",
        "RBA",
        "RCA",
        "RBC",
        "EMG"
      ],
      // eslint-disable-next-line
      riskAssessmentTypeOptions: [
        "Baseline",
        "Maintenance",
        "Project",
        "Legal"
      ],
      // eslint-disable-next-line
      riskAssessmentConditionOptions: [
        "Operations",
        "Maintenance",
        "Inspection",
        "Testing",
        "Startup",
        "Shutdown",
        "Isolation",
        "Lifting",
        "Height",
        "Underground",
        "Project"
      ],
      // eslint-disable-next-line
      riskAssessmentTimeOptions: [
        "HD1",
        "HD2",
        "HD3",
        "HD4",
        "HD5",
        "HDU"
      ],
      // eslint-disable-next-line
      riskRecommendationOptions: [
        "Monitor",
        "Controls",
        "Barrier",
        "NA"
      ],
      // eslint-disable-next-line
      themeOptions: [
        "Business",
        "Technical",
        "Maintenance",
        "Operations",
        "Project"
      ],
      // eslint-disable-next-line
      levelOptions: [
        "Company",
        "Facility",
        "System",
        "Asset",
        "Equipment",
        "Material",
        "Situation",
        "Work"
      ],
      // eslint-disable-next-line
      longOptions: [
        "Design",
        "Temp",
        "Perm"
      ],
      // eslint-disable-next-line
      typeOptions: [
        "Baseline",
        "Emergent",
        "Reliability",
        "Vulnerability",
        "Opportunity"
      ],
      riskMethodOptions: [
        "General",
        "Standard",
        "Corporate",
        "Independent",
        "Ops Risk",
        "Workshop"
      ],
      // eslint-disable-next-line
      timeOptions: [
        "Cyclical",
        "Seasonal",
        "Condition",
        "Random",
        "Continuous"
      ],
      // eslint-disable-next-line
      riskStrengthStatusOptions: [
        "Engineer",
        "Managed",
        "Weak",
        "Incomplete",
        "Strong"
      ],
      // eslint-disable-next-line
      riskControlStatusOptions: [
        "Weak",
        "Manage",
        "Strong"
      ],
      // eslint-disable-next-line
      riskAnalysisMethodOptions: [
        "Risk Ranking",
        "Reasonable",
        "RCA",
        "ALARP",
        "Best Practice"
      ],
      // eslint-disable-next-line
      // riskConsequenceOptions: [
      //   // eslint-disable-next-line
      //   "A", "B", "C", "D", "E", "F", "G", "H", "I", "J"
      // ],
      // eslint-disable-next-line
      riskConsequenceOptions: ["A", "B", "C", "D", "E", "F"],
      // eslint-disable-next-line
      riskConsequenceValueOptions: [
        // eslint-disable-next-line
        10, 9, 8, 7, 6, 5, 4, 3, 2, 1
      ],
      // eslint-disable-next-line
      // riskLikelihoodOptions: [
      //   // eslint-disable-next-line
      //   "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"
      // ],
      // eslint-disable-next-line
      riskLikelihoodOptions: ["0", "1", "2", "3", "4", "5"],
      // eslint-disable-next-line
      riskLikelihoodValueOptions: [
        // eslint-disable-next-line
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10
      ],
      // eslint-disable-next-line
      riskPriority: [
        "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"
      ],
      riskRanking: [
        // eslint-disable-next-line
        "A0", "A1", "A2", "A3", "A4", "A5",
        // eslint-disable-next-line
        "B0", "B1", "B2", "B3", "B4", "B5",
        // eslint-disable-next-line
        "C0", "C1", "C2", "C3", "C4", "C5",
        // eslint-disable-next-line
        "D0", "D1", "D2", "D3", "D4", "D5",
        // eslint-disable-next-line
        "E0", "E1", "E2", "E3", "E4", "E5",
        // eslint-disable-next-line
        "F0", "F1", "F2", "F3", "F4", "F5",
        // eslint-disable-next-line
        "NA"
      ],
      // eslint-disable-next-line
      solutionCategory: [
        "Financial",
        "Production",
        "Productivity",
        "Cost",
        "Emissions",
        "Environment",
        "Process Safety",
        "Personal Safety",
        "Maintenance",
        "Reputation",
        "Compliance",
        "Water"
      ],
      // eslint-disable-next-line
      riskCategoryOptions: [
        "Financial",
        "Production",
        "Efficiency",
        "Cost",
        "Environment",
        "Process Safety",
        "Personal Safety",
        "Maintenance",
        "Reputation",
        "Compliance",
        "Equipment Trip",
        "Equipment Damage",
        "Facility Shutdown",
        "System Trip",
        "Budget Impact",
        "Supply Chain",
        "Plan Impact",
        "Maintenance Impact",
        "Regulatory Breach"
      ],
      // eslint-disable-next-line
      solutionType: [
        "Project",
        "Major Project",
        "Maint Plan",
        "Refill",
        "Repair",
        "Replace",
        "Safety Audit",
        "Simple",
        "Software"
      ],
      // eslint-disable-next-line
      solutionSchedule: [
        "Online",
        "Offline",
        "+1D",
        "+3D",
        "+7D",
        "+14D",
        "+1M",
        "+3M",
        "+6M",
        "+9M",
        "+1Y",
        "Plan"
      ],
      // eslint-disable-next-line
      solutionRisk: [
        "Access",
        "Approval",
        "Execution",
        "Technical"
      ],
      // eslint-disable-next-line
      solutionConsequence: [
        "Major",
        "High",
        "Medium",
        "Low",
        "Negligible"
      ],
      // eslint-disable-next-line
      riskConsequence: [
        "Severe",
        "High",
        "Medium",
        "Low",
        "Tolerable"
      ],
      // eslint-disable-next-line
      riskReview: [
        "NA",
        "1D",
        "1W",
        "2W",
        "1M",
        "3M",
        "6M",
        "1Y",
        "2Y",
        "4Y",
        "5Y",
        "8Y",
        "10Y"
      ],
      // eslint-disable-next-line
      maintStrategyFreq: [
        "1W",
        "2W",
        "1M",
        "3M",
        "6M",
        "9M",
        "1Y",
        "2Y",
        "3Y",
        "4Y",
        "5Y",
        "6Y",
        "7Y",
        "8Y",
        "9Y",
        "10Y",
        "11Y",
        "12Y"
      ],
      // eslint-disable-next-line
      riskExposure: [
        "Now",
        "Startup",
        "Shutdown"
      ],
      // eslint-disable-next-line
      riskEscalation: [
        "Likley",
        "Possible",
        "Unlikley"
      ],
      // eslint-disable-next-line
      solutionLikelihood: [
        "Certain",
        "Hi Likely",
        "Likley",
        "Possible",
        "Unlikley"
      ],
      // eslint-disable-next-line
      riskReoccurance: [
        "Cont",
        "1/E",
        "1/1D",
        "1/1M",
        "1/3M",
        "1/6M",
        "1/1Y",
        "1/2Y",
        "1/4Y",
        "1/6Y",
        "1/8Y",
        "1/10Y",
        "1/12Y",
        "1/15Y",
        "1/20Y",
        "1/25Y"
      ],
      // eslint-disable-next-line
      riskEscalationType: [
        "Time",
        "Event",
        "Const"
      ],
      // eslint-disable-next-line
      riskReasonableType: [
        "ALARP",
        "Controls",
        "SFARP",
        "Tolerable"
      ],
      // eslint-disable-next-line
      riskControlResponsibility: [
        "Engineering",
        "Maintenance",
        "Operations",
        "Vendor"
      ],
      // eslint-disable-next-line
      riskControlType: [
        "Control",
        "Required",
        "Normal"
      ],
      // eslint-disable-next-line
      riskBusinessImpact: [
        "Major",
        "Minor",
        "Company",
        "Facility",
        "Asset"
      ],
      // eslint-disable-next-line
      type: [
        "Delay",
        "Opportunity",
        "Productivity",
        "Risk",
        "Vulnerability",
        "Waste",
        "Trip"
      ],
      // eslint-disable-next-line
      strategyDriver: [
        "Compliance",
        "Reliability",
        "Safety"
      ],
      // eslint-disable-next-line
      planDriver: [
        "Compliance",
        "Reliability",
        "Safety"
      ],
      // eslint-disable-next-line
      roItemType: [
        "Control",
        "Evaluation",
        "Solution"
      ],
      // eslint-disable-next-line
      maintAssuranceType: [
        "Assurance"
      ],
      // eslint-disable-next-line
      riskControlDegradation: [
        "Event",
        "Human",
        "Project",
        "Time",
        "NA"
      ],
      // eslint-disable-next-line
      riskControlType: [
        "Engineering",
        "Inspection",
        "Procedure",
        "Routine",
        "Time",
        "NA"
      ],
      // eslint-disable-next-line
      riskControlConsequence: [
        "Severe",
        "High",
        "Medium",
        "Low"
      ],
      // eslint-disable-next-line
      riskOptions: [
        "H",
        "M",
        "L"
      ],
      // eslint-disable-next-line
      riskOpsOptions: [
        "Severe",
        "High",
        "Medium",
        "Low",
        "Negligible"
      ],
      // eslint-disable-next-line
      riskLikelihood: [
        "Certain",
        "Likely",
        "Possible",
        "Unlikely",
        "Remote"
      ],
      // eslint-disable-next-line
      actionWords: [
        "Function Test",
        "Inspection",
        "Inspection and Test",
        "Replace",
        "Refurbish"
      ],
      // eslint-disable-next-line
      solutionRanking: [
        "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"
      ]
    };
  }
};
